import { render } from "./financial-period.vue?vue&type=template&id=0681c563&scoped=true"
import script from "./financial-period.vue?vue&type=script&lang=js"
export * from "./financial-period.vue?vue&type=script&lang=js"

import "./financial-period.vue?vue&type=style&index=0&id=0681c563&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0681c563"]])

export default __exports__